import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceImportLine } from 'src/app/models/invoice-import.model';

@Component({
  selector: 'app-invoice-draft-product-dialog',
  templateUrl: './invoice-draft-product-dialog.component.html',
  styleUrls: ['./invoice-draft-product-dialog.component.scss'],
})
export class InvoiceDraftProductDialogComponent implements OnInit {
  @Input() line!: InvoiceImportLine;
  @Input() categories: { _id: string; name: string }[] = [];

  form!: FormGroup;

  constructor(
    protected ref: NbDialogRef<InvoiceDraftProductDialogComponent>,
    private fb: FormBuilder,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const defaultPrice = this.line.suggestedSalePrice ?? this.line.recommendedRetailInclVat ?? null;
    this.form = this.fb.group({
      name: [this.line.name || '', [Validators.required, Validators.minLength(1)]],
      price: [defaultPrice, [Validators.required, Validators.min(0.01)]],
      categoryId: ['', Validators.required],
    });
  }

  cancel(): void {
    this.ref.close(null);
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const raw = this.form.getRawValue();
    this.ref.close({
      name: String(raw.name).trim(),
      price: Number(raw.price),
      categoryId: raw.categoryId,
    });
  }
}
